import m from 'mithril';
import {trans, has_permission} from "./helpers";

import CreateExercise from './new_challenge_creator/createExercise.js';
import EditExerciseContent from "./new_challenge_creator/editExerciseContent.js";
import ExerciseCreated from "./new_challenge_creator/exerciseCreated.js";

let challenge_state = require('./new_challenge_creator/challengeState.js');

class Exercise{
    oninit() {
        challenge_state.new_exercise = challenge_state.get_empty_exercise();
        challenge_state.current_step = 'loading';

        if (challenge_state.id_exercise) {
            challenge_state.mode = 'update_exercise';
        } else {
            challenge_state.mode = 'insert_exercise';
        }

        if (challenge_state.mode == 'insert_exercise') {
            challenge_state.current_step = 'create_exercise';
        }
    }
    
    view() {
        return [
            challenge_state.current_step == 'loading' &&
            m('.general-loader', ''),

            challenge_state.current_step == 'create_exercise' &&
            m(CreateExercise),

            challenge_state.current_step == 'edit_exercise_content' &&
            m(EditExerciseContent),

            challenge_state.current_step == 'saving_exercise' &&
            m('div', trans('challenge.saving')),

            challenge_state.current_step == 'exercise_created' &&
            m(ExerciseCreated),

            challenge_state.current_step == 'not_permitted_to_edit_public' &&
            [
                m('div', trans('exercises.not_permitted_to_edit_public_text')),
                m('br'),
                m('a.btn.btn--main', {
                    href: '/myprofile/exercises',
                }, trans('challenge.back_to_profile')),
            ]
        ]
    }
}

function get_exercise() {
    m.request('/api/exercises' +
        '?id_exercise='+ encodeURIComponent(challenge_state.id_exercise) +
        '&part=group_items,sports')
        .then(d => {
            if (d.length > 0)
                d = d[0];

            challenge_state.new_exercise.id_exercise = d.id_exercise;
            challenge_state.new_exercise.title = d.title;
            challenge_state.new_exercise.short_description = d.short_description;
            challenge_state.new_exercise.url_poster = d.url_poster;
            challenge_state.new_exercise.validated = d.validated*1;
            challenge_state.new_exercise.requested_public = d.requested_public*1;
            challenge_state.new_exercise.public = d.public*1;
            challenge_state.new_exercise.unlisted = d.unlisted*1;

            challenge_state.new_exercise.sports = {
                list: d.sports
            }; 

            let groups = {};

            d.group_items.forEach(group_item => {
                if (!(group_item.group_code in groups)) {
                    groups[group_item.group_code] = {
                        id_group: group_item.id_group*1,
                        list: []
                    };
                }

                groups[group_item.group_code].list.push({
                    id_group_item: group_item.id_group_item*1,
                    title: group_item.title,
                    code: group_item.code
                });
            });

            challenge_state.new_exercise.groups = groups;


            if (challenge_state.new_exercise.validated == 1 && challenge_state.new_exercise.requested_public == 1 && !has_permission('exercises.canCreatePublic')) {
                challenge_state.current_step = 'not_permitted_to_edit_public';
            } else {
                // challenge_state.current_step = 'select_exercises';
                challenge_state.current_step = 'create_exercise';
            }

            // challenge_state.current_step = 'edit_exercise_content';
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function init(rootElement, id_exercise) {

    if (!rootElement) {
        return;
    }

    if (id_exercise) {
        challenge_state.id_exercise = id_exercise;
        challenge_state.mode = 'update_exercise';

        get_exercise();
    }

    m.mount(rootElement, Exercise);
}

export default init;
